window.addEventListener('load', function(event) {
	const datesPagination = new Swiper('.prod-history__dates', {
		wrapperClass: 'prod-history__dates-track',
		slideClass: 'prod-history__date',
		speed: 500,
		centeredSlidesBounds: true,
		centeredSlides: true,
		slidesPerView: 5,
		slideToClickedSlide: true,
		breakpoints: {
			// when window width is >= 320px
			320: {
				direction: 'horizontal',
			},
			// when window width is >= 920px 
			768: {},
			1025: {
				direction: 'vertical',
			}
		}
	});

	const historySlider = new Swiper('.prod-history__gallery', {
		wrapperClass: 'prod-history__gallery-track',
		slideClass: 'prod-history__gallery-item',
		speed: 500,
		autoHeight: true,
		// thumbs: {
		//   swiper: datesPagination,
		//   autoScrollOffset: 0
		// },
		mousewheel: {
			invert: false,
		},
		slidesPerView: 1,
		breakpoints: {
			// when window width is >= 320px
			320: {
				direction: 'horizontal',
			},
			// when window width is >= 920px 
			768: {},
			1025: {
				direction: 'vertical',
			}
		}
	});
	
	document.querySelector(".prod-history__date:nth-child(1)").classList.add("prod-history__date--active");
	
	document.querySelectorAll('.prod-history__date').forEach(date => {
		date.addEventListener('click', function(){
			let navigationElem = document.querySelector('.prod-history__date--active');
			if (navigationElem !== null) {
                navigationElem.classList.remove('prod-history__date--active');
            }
			//document.querySelector('.prod-history__date--active').classList.remove('prod-history__date--active');
			this.classList.add('prod-history__date--active');

			let index = this.dataset.index;

			historySlider.slideTo(index, 500);
		})
	})

	historySlider.on('slideChange', function (e) {
		console.log(e);
		let index = e.realIndex;
		// console.log(e);
		// console.log(index);
		document.querySelector('.prod-history__date--active').classList.remove('prod-history__date--active');
		document.querySelector(`.prod-history__date[data-index="${index}"]`).classList.add('prod-history__date--active');
		//datesPagination.slideTo(index, 500);
	});
  


  // datesPagination.controller.control = historySlider;
  // historySlider.controller.control = datesPagination;

  // document.querySelectorAll('.prod-history__date').forEach(item => {
  //   item.addEventListener('click', function(){
  //     let index = this.dataset.index;
  //     console.log(index);
  //     // datesPagination.slideTo(index);
  //     // historySlider.slideTo(index);
  //   })
  // })

  // datesPagination.on('slideChange', function (e) {
  //   console.log('slide changed');

  //   console.log(e);
  // });

  if (window.outerWidth > 1024) {
    
  }
}, false);